import { FC } from 'react';
import { Flex, Image } from '@chakra-ui/react';

import magnifyingGlass from 'assets/brand/mag-glass.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import locales from './locales';

interface NoResultProps {
  onResetFilters: () => void;
}

export const NoResult: FC<NoResultProps> = ({ onResetFilters }) => (
  <Flex
    alignItems="center"
    flexDirection="column"
    gap="space-16"
    marginTop="space-24"
  >
    <Image alt="" role="presentation" src={magnifyingGlass} width="180px" />

    <Text fontWeight="weight-500" size="lg" variant="primary">
      {locales.noResult}
    </Text>

    <Button onClick={onResetFilters} variant="inline-primary">
      {locales.reset}
    </Button>
  </Flex>
);

export default NoResult;
